import { UnderwritingOffer } from '_gql'

const OFFER_TYPE_TRACKING_LABELS: Record<UnderwritingOffer, 'prepay' | 'standard' | 'variable'> = {
  [UnderwritingOffer.FIXED_LINE]: 'standard',
  [UnderwritingOffer.VARIABLE_LINE]: 'variable',
  [UnderwritingOffer.SECURED_LINE]: 'prepay',
}

export const getOfferTypeTrackingLabel = (offerType: UnderwritingOffer | null | undefined) =>
  offerType ? OFFER_TYPE_TRACKING_LABELS[offerType] : 'undefined'

export default getOfferTypeTrackingLabel
